import Box from '@mui/material/Box';
import { styled, SxProps, Theme } from '@mui/material/styles';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '80px',
  height: '80px',
  borderRadius: '100%',
  backgroundColor: theme.palette.neutrals.beige3,
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(3)
}));

export const CustomStyledBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'sx'
})<{ sx?: SxProps<Theme> }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '80px',
  height: '80px',
  borderRadius: '100%',
  backgroundColor: theme.palette.neutrals.beige3,
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(3)
}));
